import { render, staticRenderFns } from "./dailyAirReport04.vue?vue&type=template&id=53169c54"
import script from "./dailyAirReport04.vue?vue&type=script&lang=js"
export * from "./dailyAirReport04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53169c54')) {
      api.createRecord('53169c54', component.options)
    } else {
      api.reload('53169c54', component.options)
    }
    module.hot.accept("./dailyAirReport04.vue?vue&type=template&id=53169c54", function () {
      api.rerender('53169c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/air/dailyAirReport04.vue"
export default component.exports